module.exports = __webpack_public_path__ + "5e69f7a3c6f2147eaf80084b1c7e4820.svg";